import { Node, mergeAttributes } from "@tiptap/core";

export const CustomPTag = Node.create({
	name: "customParagraph",

	group: "block",

	content: "inline*",

	parseHTML() {
		return [
			{
				tag: "p",
				getAttrs: element => {
					const style = element.getAttribute("style") || "";
					return { style };
				}
			}
		];
	},

	renderHTML({ HTMLAttributes }) {
		return ["p", mergeAttributes(HTMLAttributes), 0];
	},

	addAttributes() {
		return {
			style: {
				default: "",
				parseHTML: element => element.getAttribute("style"),
				renderHTML: attributes => {
					return attributes.style ? { style: attributes.style } : {};
				}
			}
		};
	}
});
